<motn-drawer-gap-from-top
  (clickedOutside$)="closed$.emit($event)"
  [addToZIndex]="1"
  >
  <h2> Bulk Edit </h2>
  @if (!hasTiles) {
    <h3
      class="empty-state"
      >
      Looks like there are no tiles you have permission to edit here
    </h3>
  }
  @for (tile of tiles; track tile) {
    <div
      class="tile"
      >
      <div class="tile-inputs">
        <div class="tile-badges">
          <div class="tile-badges-row">
            <motn-tile-icon [appearance]="tile.Appearance"></motn-tile-icon>
            <motn-pill [squareLetter]="'t'">{{ tile.ID }}</motn-pill>
          </div>
          @let facetText = getFacetText(tile);
          @if (facetText) {
            <span class="tile-facets">{{ facetText }}</span>
          }
        </div>
        <div class="text-input">
          <input
            [(ngModel)]="tile.Name"
            >
          <div
            class="label"
            >
            Tile Name
          </div>
        </div>
        <div class="text-input">
          <input
            [(ngModel)]="tile.Appearance.DisplayName"
            >
          <div
            class="label"
            >
            Display Name
          </div>
        </div>
        @if (tile.typeSupportsReadWrite()) {
          <div
            >
            <select
              [(ngModel)]="tile.Structure['Writable']"
              >
              <option
                [innerText]="'Read-Only'"
                [ngValue]="false"
              ></option>
              <option
                [innerText]="'Read+Write'"
                [ngValue]="true"
              ></option>
            </select>
            <div
              class="label"
              >
              Writability
            </div>
          </div>
        }
      </div>
      @if (tile.Type === 'SUPER_FOLDER') {
        <div
          class="tile-children"
          >
          @for (childTile of tile.children; track childTile) {
            <div
              class="tile-child"
              >
              <div class="tile-badges">
                <div class="tile-badges-row">
                  <motn-tile-icon [appearance]="childTile.Appearance"></motn-tile-icon>
                  <motn-pill [squareLetter]="'t'">{{ childTile.ID }}</motn-pill>
                </div>
                @let childFacetText = getFacetText(childTile);
                @if (childFacetText) {
                  <span class="tile-facets">{{ childFacetText }}</span>
                }
              </div>
              <div class="text-input">
                <input
                  [(ngModel)]="childTile.Name"
                  >
                <div
                  class="label"
                  >
                  Tile Name
                </div>
              </div>
              <div class="text-input">
                <input
                  [(ngModel)]="childTile.Appearance.DisplayName"
                  >
                <div
                  class="label"
                  >
                  Display Name
                </div>
              </div>
              @if (childTile.typeSupportsReadWrite()) {
                <div
                  class="writability-input"
                  >
                  <select
                    [(ngModel)]="childTile.Structure['Writable']"
                    >
                    <option
                      [innerText]="'Read-Only'"
                      [ngValue]="false"
                    ></option>
                    <option
                      [innerText]="'Read+Write'"
                      [ngValue]="true"
                    ></option>
                  </select>
                  <div
                    class="label"
                    >
                    Writability
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }


  <div class="buttons">
    @if (hasTiles) {
      <button
        (click)="save()"
        [class.loading]="savingInProcess"
        >
        <span>Save</span>
        <motn-spinner></motn-spinner>
      </button>
    }

    <button
      (click)="closed$.emit(null)"
      class="alt"
      >
      <span>Cancel</span>
      <motn-spinner></motn-spinner>
    </button>
  </div>
</motn-drawer-gap-from-top>
